var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.712,
    height: 54.446,
    viewBox: "0 0 55.712 54.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1784",
    "data-name": "Grupo 1784",
    transform: "translate(-1806.59 -37.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1783",
    "data-name": "Grupo 1783",
    transform: "translate(1806.59 37.99)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 27.223,
    cy: 27.856,
    rx: 27.223,
    ry: 27.856,
    transform: "translate(0 54.446) rotate(-90)",
    fill: "#82ab40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M13.2,8.669a6.769,6.769,0,1,0,6.769,6.769A6.758,6.758,0,0,0,13.2,8.669Zm0,11.169a4.4,4.4,0,1,1,4.4-4.4,4.409,4.409,0,0,1-4.4,4.4ZM21.825,8.392a1.579,1.579,0,1,1-1.579-1.579A1.575,1.575,0,0,1,21.825,8.392Zm4.483,1.6a7.813,7.813,0,0,0-2.133-5.532A7.864,7.864,0,0,0,18.644,2.33c-2.18-.124-8.713-.124-10.892,0A7.853,7.853,0,0,0,2.22,4.457,7.839,7.839,0,0,0,.088,9.989c-.124,2.18-.124,8.713,0,10.892A7.813,7.813,0,0,0,2.22,26.413a7.874,7.874,0,0,0,5.532,2.133c2.18.124,8.713.124,10.892,0a7.813,7.813,0,0,0,5.532-2.133,7.864,7.864,0,0,0,2.133-5.532c.124-2.18.124-8.707,0-10.886ZM23.492,23.22a4.455,4.455,0,0,1-2.51,2.51c-1.738.689-5.861.53-7.782.53s-6.05.153-7.782-.53a4.455,4.455,0,0,1-2.51-2.51c-.689-1.738-.53-5.861-.53-7.782s-.153-6.05.53-7.782a4.455,4.455,0,0,1,2.51-2.51c1.738-.689,5.861-.53,7.782-.53s6.05-.153,7.782.53a4.455,4.455,0,0,1,2.51,2.51c.689,1.738.53,5.861.53,7.782S24.181,21.488,23.492,23.22Z",
    transform: "translate(1821.249 49.775)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstagram);
export default __webpack_public_path__ + "static/media/ico_instagram.9d1b67f00d210591b6a68f1295b3efab.svg";
export { ForwardRef as ReactComponent };